import React from 'react';

import {Select} from 'components/Form';
import {config} from 'config/config';
import useQueryApiClient from 'utils/useApiClient';

import type { DefaultOptionType } from 'antd/es/select';

const TimeZoneInput: React.FC<any> = (props) => {
  const {data: timeZones, isLoading: getTimeZonesLoading} = useQueryApiClient({
        request: {
            url: config.api.routes.enums.timeZoneTypes,
            method: 'GET',
        },
    });

  const parseTimeZones = (timeZoneResponseArray: any): DefaultOptionType[] => {
    let timeZonesParsed = Object.keys(timeZoneResponseArray).map(el => {
      let label = el;
      let numericValue = parseInt(el);

      if (numericValue > 0) {
        label = `+${el}:00`
      } else if (numericValue < 0) {
        label = `${el}:00`
      }

      return ({
        value: el,
        label: label
      })
    })

    return timeZonesParsed;
  };

  return (
    <Select
      manualOptions={parseTimeZones(timeZones)}
      loading={getTimeZonesLoading}
      isResponseArray={true}
      {...props}
    />
  )
}

export default TimeZoneInput;
